"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompensationCycleDisplayStatusContract () {
        return CompensationCycleDisplayStatusContract;
    },
    get CompensationCycleStatusContract () {
        return CompensationCycleStatusContract;
    },
    get CompensationDecisionStatusContract () {
        return CompensationDecisionStatusContract;
    }
});
const _zod = require("zod");
const CompensationCycleStatusContract = _zod.z.enum([
    "active",
    "completed",
    "cancelled"
]);
const CompensationCycleDisplayStatusContract = _zod.z.enum([
    "In Progress",
    "Overdue",
    "Scheduled",
    "Completed",
    "Cancelled"
]);
const CompensationDecisionStatusContract = _zod.z.enum([
    "Not Submitted",
    "Submitted",
    "Approved"
]);
